/**
 * Controller for AppManager
 */
define('controllers/myservices/common/submit-success.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('submitSuccess', ['$scope','$state','$stateParams',
        function ($scope,$state,$stateParams) {
            $scope.back2list = back2list;
            $scope.isUpdate = false;
            var Model = $scope.Model = {};
            var serviceItem = $stateParams.serviceItem;
            var product = $stateParams.product;
            if (product && product.serviceSingle && product.serviceSingle.srvSerialNo){
                $scope.isUpdate = true;
            }
            var services = mainCons.myserviceList.services;
            services.forEach(function (service) {
                if (service.serviceItem == serviceItem) {
                    Model.currService = angular.copy(service);
                }
            });

            function back2list(){
                $state.go("myServiceList",{serviceItem:serviceItem});
            }
        }]);
});
